import { ServiceKind } from "@bitory-gmbh/bsm";
import { NavLink } from "react-router";
import { useDocumentPath } from "@/services/backend/documents/components/use-document-path";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { Button } from "@/shared/components/ui/button";
import { DocumentNumberById } from "@/services/backend/numbers/components/document-number";

export function DocumentLink({
  documentId,
  documentKind,
  serviceKind,
  processId,
}: {
  documentId: string;
  documentKind: string;
  serviceKind: ServiceKind;
  processId: string;
}) {
  const { path } = useDocumentPath({
    documentId,
    documentKind,
    serviceKind: serviceKind as GSMServiceKind,
    processId,
  });

  return (
    <Button asChild variant="link" size="sm" className="whitespace-normal">
      {path ? (
        <NavLink to={path!}>
          <DocumentNumberById documentId={documentId} />
        </NavLink>
      ) : (
        <DocumentNumberById documentId={documentId} />
      )}
    </Button>
  );
}
